import React from 'react';

const FallBackPage: React.FC = () => {
    return (
        <>
            <h2>404! OOPS</h2>
        </>
    )
};

export default FallBackPage;
